export var NewUserValidationModeType;
(function (NewUserValidationModeType) {
    NewUserValidationModeType["Automatic"] = "Automatic";
    NewUserValidationModeType["Manual"] = "Manual";
})(NewUserValidationModeType || (NewUserValidationModeType = {}));
//# sourceMappingURL=new-user-validation-mode.js.map